import './share-image.scss'
import dialogPolyfill from 'dialog-polyfill'
import { ReactNode, useCallback, useEffect, useRef, useMemo } from 'react'
import { isNative, NativeRequest } from 'onemt-sdk-native'
import { QRCodeCanvas } from 'qrcode.react'
import html2canvas from 'html2canvas'
import { $t } from '@/i18n/LocalContext'
import { toast } from '@/utils'
import { clickReport } from '@app/report'

interface ShareImageProps {
  open: boolean
  onClose: () => void
  children: ReactNode[]
  qrcodeUrl: string
  code: string
}

export default function ShareImage(props: ShareImageProps) {
  const { open, onClose, children, qrcodeUrl, code } = Object.assign(
    {
      open: false,
    },
    props
  )

  const modalRef = useRef<HTMLDialogElement | null>(null)

  useEffect(() => {
    const modalElem = modalRef.current
    if (modalElem) {
      dialogPolyfill.registerDialog(modalElem)
      modalElem.onkeydown = (e) => {
        if (e.key === 'Escape') {
          e.preventDefault()
        }
      }
      if (open) {
        modalElem.showModal()
      }
    }

    return () => {
      if (modalElem) {
        modalElem.open = false
      }
    }
  }, [open])

  const stopPropagation = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation()
  }

  const close = () => {
    onClose instanceof Function && onClose()
  }

  const handleShare = useCallback(
    (
      /** 分享类型 FACEBOOK = 1 TWITTER = 2 WHATSAPP = 3 WECHATFRIENDS = 5 WECHATCIRCLES = 6 INSTAGRAM = 7 */
      type: number
    ) => {
      const title = $t('邀请活动分享标题')
      const content = $t('邀请活动分享描述').replace('{invitationCode}', code)
      // console.log('handleShare =>', title, content, qrcodeUrl, code)
      if (isNative()) {
        NativeRequest('share', {
          title,
          content,
          type,
          url: qrcodeUrl,
        })
      } else {
        if (type === 1) {
          clickReport('FBshare2')
          window.location.href = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
            qrcodeUrl
          )}`
        }
        if (type === 2) {
          clickReport('TWshare2')
          window.location.href = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
            qrcodeUrl
          )}`
        }
      }
    },
    [code, qrcodeUrl]
  )

  const download = useCallback(() => {
    clickReport('shareDownload')

    const canvasElem = document.querySelector<HTMLElement>(
      '.share-image-block .share-image'
    )
    if (!canvasElem) return

    html2canvas(canvasElem).then((canvas) => {
      const a = document.createElement('a')
      a.href = canvas.toDataURL('image/png')
      a.download = `share_img_${+new Date()}.png`
      if (isNative()) {
        NativeRequest('saveImage', {
          uri: canvas.toDataURL('image/png'),
        })
      } else {
        a.click()
      }
      setTimeout(() => {
        toast($t('保存成功'), true)
      }, 1000)
    })
  }, [qrcodeUrl])

  return open ? (
    <>
      <dialog ref={modalRef} className="share-image-modal" onClick={close}>
        <div className="share-image-block" onClick={stopPropagation}>
          <div className="share-image">
            {children[0]}
            <QRCodeCanvas
              className="share-image-qrcode"
              level="H"
              value={qrcodeUrl}
            />
          </div>
          {children[1]}
        </div>
        <div className="share-image-btn-list" onClick={stopPropagation}>
          <a className="share-image-fb" onClick={() => handleShare(1)}></a>
          <a className="share-image-x" onClick={() => handleShare(2)}></a>
          <a className="share-image-download" onClick={download}></a>
        </div>
        <div className="share-image-close"></div>
      </dialog>
      <div className="backdrop"></div>
    </>
  ) : null
}
